import SectionContainer from "@/common/SectionContainer";
import { DEFAULT_COUNT } from "@/constants/posts";

const NewsroomLoading = () => {
  return (
    <>
      {/* Hero Banner Skeleton */}
      <div className="relative w-full min-h-[360px] md:min-h-[450px] bg-gray-200 animate-pulse" />

      <SectionContainer className="bg-[#f5f5f5]">
        <div className="text-[#222222] px-2 sm:px-4 py-5 md:py-16 max-w-[1280px] mx-auto">
          {/* Card Grid Skeleton */}
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-x-4 gap-y-8 mt-5">
            {Array.from({ length: DEFAULT_COUNT }).map((_, i) => (
              <div key={i}>
                <div className="aspect-[16/9] bg-gray-200 rounded-sm animate-pulse" />
                <div className="mt-4 space-y-2">
                  <div className="h-5 w-3/4 bg-gray-200 rounded animate-pulse" />
                  <div className="h-4 w-full bg-gray-200 rounded animate-pulse" />
                  <div className="h-4 w-2/3 bg-gray-200 rounded animate-pulse" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </SectionContainer>
    </>
  );
};

export default NewsroomLoading;
